// extracted by mini-css-extract-plugin
module.exports = {"s1z0sj4v":"s1z0sj4v"};